// @flow
import {makeStyles} from '@material-ui/core/styles';
import React from 'react';
import PropTypes from 'prop-types';
import {Link, Route, Switch, useLocation} from 'react-router-dom';
import Typography from '@material-ui/core/Typography';
import Hidden from '@material-ui/core/Hidden';

import CreditCardIcon from '@material-ui/icons/CreditCard';
import GeneralContainer from '../general/containers/GeneralContainer';
import {ButtonGroup, Chip, Grid} from '@material-ui/core';
import PaymentMethodContainer from '../payment-method/containers/PaymenthMethodContainer';
import AlertDueDateTier from '../../tiers/components/AlertDueDateTier/AlertDueDateTier';
import CustomButton from '../../../elements/CustomButton/CustomButton';
import SalesProcessContainer from '../sales-process/containers/SalesProcessContainer';
import salesIcon from '../../../assets/img/salesIcon.png';
import TaxesContainer from '../taxes/containers/TaxesContainer';
import TaxesIcon from '@material-ui/icons/LocalAtm';

import {
  ArrowBack,
  HelpTwoTone,
  Info,
  InfoOutlined,
  LocalShipping,
  PlayCircleFilledTwoTone,
  LocalConvenienceStore,
  GroupAdd,
  Palette,
} from '@material-ui/icons';
import {colors} from '../../../assets/styles/colors';
import {useIsFeatureInTier} from '../../../utils/component';

import type {User, Store} from '../../../entities';
import type {Node} from 'react';
import AccountsContainer from '../accounts/containers/AccountsContainer';
import {TIENDADA_LINKS} from '../../../constants/tiendada-links';
import CustomizeContainer from '../../my-store/customize/containers/CustomizeContainer';
import {useIsMinimalPlan} from '../../store/utils';
import {useStoreCountry} from '../../country/utils';
import Logistics from '../logistics/logistics/Logistics';
import UpgradeIcon from '../../../elements/icons/UpgradeIcon';
import CustomChip from '../../../elements/CustomChip';

type ConfigureSubRoute = {
  show: boolean,
  exact?: boolean,
  name: string | Node,
  path: string,
  component?: Node,
  icon: Node,
  disabled?: boolean,
  tierRestricted?: boolean,
  extra?: Node,
};

type Props = {
  store: Store,
  user: User,
};

export const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100%',
    background: '#f8f9fb',
  },
  navBackground: {
    [theme.breakpoints.down('sm')]: {
      background: 'white !important',
    },
  },
  content: {
    maxWidth: 1300,
    display: 'flex',
    flexDirection: 'column',
    // minHeight: '100%',
    // overflow: 'auto',
    padding: '.75rem',
    [theme.breakpoints.up('sm')]: {
      padding: '1rem',
    },
  },
  dividerVertical: {
    margin: theme.spacing(0, 1),
    background: colors.grey300,
  },
  contentBottom: {
    // flexGrow: 1,
    // paddingTop: 100,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-end',
    // height: '100%',
    // marginBottom: 64,
    background: '#f8f9fb',
    // overflow: 'auto',
    padding: theme.spacing(0, 4),
    [theme.breakpoints.down('sm')]: {
      marginBottom: 140,
    },
    [theme.breakpoints.down('xs')]: {
      padding: theme.spacing(0, 2),
    },
  },
  headerWrapper: {
    // background: '#f8f9fb',
    // marginBottom: theme.spacing(2),
  },
  title: {
    fontSize: '24px',
    fontWeight: 600,
    color: 'black',
    [theme.breakpoints.down('xs')]: {
      fontSize: '18px',
    },
  },
  ayudaButton: {
    backgroundColor: 'white',
    color: colors.purple3,
    padding: '4px 13px',
    boxShadow:
      '0px 0px 1px rgba(40, 41, 61, 0.08), 0px 0.5px 2px rgba(96, 97, 112, 0.16)',
    margin: '0 14px 0 0',
    [theme.breakpoints.down('xs')]: {
      backgroundColor: 'unset',
      color: colors.purple3,
      fontSize: '12px',
      margin: '0 16px 0 0',
      padding: 0,
      boxShadow: 'unset',
    },
  },
  tutorialsButton: {
    backgroundColor: 'white',
    color: colors.purple3,
    padding: '4px 13px',
    boxShadow:
      '0px 0px 1px rgba(40, 41, 61, 0.08), 0px 0.5px 2px rgba(96, 97, 112, 0.16)',
    [theme.breakpoints.down('xs')]: {
      backgroundColor: 'unset',
      color: colors.purple3,
      padding: 0,
      boxShadow: 'unset',
    },
  },
  subRouteHeader: {
    fontSize: '1.125rem',
    fontWeight: 600,
    padding: 12,
    marginTop: theme.spacing(3),
    display: 'flex',
    alignItems: 'center',
    // textAlign: 'left',
    // justifyContent: 'flex-start',
    backgroundColor: colors.grey300,
    color: colors.grey800,
    boxShadow:
      '0px 0px 1px rgba(40, 41, 61, 0.08), 0px 0.5px 2px rgba(96, 97, 112, 0.16)',
    borderRadius: '12px',
  },
  extraText: {
    margin: theme.spacing(0, 1),
    fontSize: '0.875rem',
    color: colors.grey700,
    fontWeight: 500,
  },
  upsellMessage: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginTop: theme.spacing(2),
    padding: theme.spacing(2),
    [theme.breakpoints.down('xs')]: {
      // flexDirection: 'column',
      padding: theme.spacing(1),
      flexWrap: 'wrap',
    },
    color: colors.purple3,
    background: colors.lightPurple,
    // opacity: 0.8,
    borderRadius: '12px',
    fontSize: '0.875rem',
  },
  upgradeTierButton: {
    marginLeft: 'auto',
    // backgroundColor: 'white',
    // color: colors.purple3,
    // padding: '4px 13px',
    // boxShadow:
    //   '0px 0px 1px rgba(40, 41, 61, 0.08), 0px 0.5px 2px rgba(96, 97, 112, 0.16)',
    backgroundColor: 'unset',
    color: colors.purple3,
    boxShadow: 'unset',
    [theme.breakpoints.down('xs')]: {
      marginTop: theme.spacing(1),
      // backgroundColor: 'unset',
      // color: colors.purple3,
      // padding: 0,
      // boxShadow: 'unset',
    },
  },
  configureButton: {
    fontSize: '1.125rem',
    fontWeight: 600,
    padding: '20px 20px',
    marginBottom: theme.spacing(2),
    textAlign: 'left',
    justifyContent: 'flex-start',
    backgroundColor: 'white',
    color: colors.grey800,
    boxShadow:
      '0px 0px 1px rgba(40, 41, 61, 0.08), 0px 0.5px 2px rgba(96, 97, 112, 0.16)',
    borderRadius: '12px',
    whiteSpace: 'pre-wrap',
  },
  disabledConfigureButton: {
    fontSize: '1.125rem',
    fontWeight: 600,
    padding: '20px 20px',
    marginBottom: theme.spacing(2),
    textAlign: 'left',
    justifyContent: 'flex-start',
    backgroundColor: 'white',
    color: colors.grey800,
    boxShadow:
      '0px 0px 1px rgba(40, 41, 61, 0.08), 0px 0.5px 2px rgba(96, 97, 112, 0.16)',
    borderRadius: '12px',
    whiteSpace: 'pre-wrap',
  },
  groupButton: {
    width: '100%',
    justifySelf: 'flex-end',
    backgroundColor: 'white',
    color: colors.purple3,
    padding: '20px 20px',
    marginBottom: theme.spacing(2),
    // justifyContent: 'flex-start',
    border: 'none',
    boxShadow:
      '0px 0px 1px rgba(40, 41, 61, 0.08), 0px 0.5px 2px rgba(96, 97, 112, 0.16)',
    borderRadius: '12px',
  },
  subRouteIcon: {
    fontSize: '1.5rem !important',
    marginRight: 12,
  },
  // containerWrap: {
  //   display: 'flex',
  //   paddingBottom: theme.spacing(12),
  // },
  subRouteNameWrap: {
    height: 56,
    position: 'sticky',
    top: 72,
    zIndex: 2,
    display: 'flex',
    alignItems: 'center',
    color: colors.grey700,
    backgroundColor: colors.grey200,
    // textAlign: 'left',
    padding: theme.spacing(2),
    boxShadow:
      '0px 0px 1px rgba(40, 41, 61, 0.08), 0px 0.5px 2px rgba(96, 97, 112, 0.16)',
  },
  subRouteNameText: {
    fontWeight: 600,
    fontSize: '1.125rem',
  },
  subRouteContent: {
    // display: 'flex',
    // flexDirection: 'column',
    // height: '100%',
    // width: '100%',
    // boxShadow:
    //   '0px 0px 1px rgba(40, 41, 61, 0.08), 0px 0.5px 2px rgba(96, 97, 112, 0.16)',
    // backgroundColor: 'white',
    // borderRadius: '12px',
    // overflow: 'hidden',
  },
  upsellMessageBottom: {
    zIndex: 1,
    display: 'flex',
    alignItems: 'center',
    alignSelf: 'center',
    maxWidth: 670,
    // justifyContent: 'space-between',
    margin: theme.spacing(2),
    padding: theme.spacing(2),
    [theme.breakpoints.down('xs')]: {
      position: 'fixed',
      bottom: 64,
      left: 0,
    },
    color: colors.purple3,
    background: colors.lightPurple,
    // opacity: 0.8,
    borderRadius: '12px',
    fontSize: '0.875rem',
  },
  newLabel: {
    background: '#F5F0FF',
    marginLeft: 10,
    fontWeight: 600,
    '& span': {
      color: '#7B39FF',
    },
  },
}));

function getTutorialLinkByPathname(pathname: string) {
  if (pathname.includes('general')) {
    return TIENDADA_LINKS.tutorials.PERSONAL_INFORMATION;
  }

  if (pathname.includes('customize')) {
    return TIENDADA_LINKS.tutorials.STORE_DESIGN;
  }

  if (pathname.includes('payment-methods')) {
    return TIENDADA_LINKS.tutorials.PAYMENT_METHODS;
  }

  if (pathname.includes('logistics')) {
    return TIENDADA_LINKS.tutorials.SHIPPING;
  }

  if (pathname.includes('sales-process')) {
    return TIENDADA_LINKS.tutorials.SALES_PROCESS;
  }

  if (pathname.includes('accounts')) {
    return TIENDADA_LINKS.tutorials.COLLABORATORS;
  }

  return;
}

export default function Configure(props: Props) {
  const {user} = props;
  const classes = useStyles();
  const location = useLocation();

  const isMinimal = useIsMinimalPlan();
  // const [drawerOpen, setDrawerOpen] = useState(false);

  const country = useStoreCountry();
  const isPeruCountry = country && country.code === 'PE';

  const hasStoreInformationFeature = useIsFeatureInTier('STORE_INFORMATION');
  const hasOrderRequiredInformationFeature = useIsFeatureInTier(
    'ORDER_REQUIRED_INFORMATION'
  );
  const hasOrderStateChangeMessagesFeature = useIsFeatureInTier(
    'ORDER_STATE_CHANGE_MESSAGES'
  );
  const hasPaymentProcessorFeature = useIsFeatureInTier('PAYMENT_PROCESSOR');

  const hasDeliveryOptionsFeature = useIsFeatureInTier('DELIVERY_OPTIONS');
  const hasCollaboratorsFeature = useIsFeatureInTier('STORE_COLLABORATOR');
  const hasPaymentINfoFeature = useIsFeatureInTier('MY_PAYMENT_INFORMATION');

  const subRoutes: {[key: string]: ConfigureSubRoute} = {
    general: {
      show: hasStoreInformationFeature,
      name: 'Información',
      path: '/configure/general',
      component: <GeneralContainer />,
      icon: <Info className={classes.subRouteIcon} />,
    },
    design: {
      show: hasStoreInformationFeature,
      name: 'Diseño',
      path: '/configure/customize',
      component: <CustomizeContainer />,
      icon: <Palette className={classes.subRouteIcon} />,
    },
    payments: {
      name: (
        <div style={{display: 'flex', alignItems: 'center'}}>
          Métodos de pago
        </div>
      ),
      path: '/configure/payment-methods',
      component: <PaymentMethodContainer />,
      icon: <CreditCardIcon className={classes.subRouteIcon} />,
      tierRestricted: !isMinimal && !hasPaymentINfoFeature,
      show: hasPaymentProcessorFeature,
    },
    logistics: {
      name: (
        <div style={{display: 'flex', alignItems: 'center'}}>
          Envíos y Recogida
          {!isMinimal && !hasDeliveryOptionsFeature && (
            /*<StarRounded style={{marginLeft: 12, color: '#FFC107'}} />*/
            <Chip label="PRO" size="small" className={classes.newLabel} />
          )}
        </div>
      ),
      path: '/configure/logistics',
      // component: <LogisticsContainer />,
      // $FlowFixMe
      component: <Logistics />,
      icon: <LocalShipping className={classes.subRouteIcon} />,
      tierRestricted: !isMinimal && !hasDeliveryOptionsFeature,
      show: hasOrderRequiredInformationFeature,
    },

    // account: {
    //   name: 'Cuenta',
    //   path: '/configure/account',
    //   component: <AccountContainer />,
    //   icon: <Person className={classes.subRouteIcon} />,
    // },
    sales: {
      show:
        hasOrderRequiredInformationFeature &&
        hasOrderStateChangeMessagesFeature,
      name: <div style={{display: 'flex', alignItems: 'center'}}>Ventas</div>,
      path: '/configure/sales-process',
      component: <SalesProcessContainer />,
      icon: (
        <img
          className={classes.subRouteIcon}
          src={salesIcon}
          alt="sales process icon"
        />
      ),
      tierRestricted: false,
    },
    taxes: {
      show: isPeruCountry,
      name: 'Impuestos',
      path: '/configure/taxes',
      component: <TaxesContainer />,
      icon: <TaxesIcon className={classes.subRouteIcon} />,
    },
    warehouseCreation: {
      name: 'Creación de almacenes',
      path: '...',
      disabled: true,
      component: <div>coming soon</div>,
      icon: <Info className={classes.subRouteIcon} />,
      show: false,
    },
    warehouseStock: {
      name: 'Movimiento de stock entre almacenes',
      path: '...',
      disabled: true,
      component: <div>coming soon</div>,
      icon: <LocalConvenienceStore className={classes.subRouteIcon} />,
      show: false,
    },
    users: {
      name: (
        <div style={{display: 'flex', alignItems: 'center'}}>
          Usuarios
          {!hasCollaboratorsFeature && (
            <CustomChip
              label={
                <>
                  Mejorar <UpgradeIcon width={18} height={18} />
                </>
              }
              color="primary"
              size="small"
            />
          )}
        </div>
      ),
      path: '/configure/accounts',
      icon: <GroupAdd className={classes.subRouteIcon} />,
      show: !!user && user.type === 'vendor-user',
      component: <AccountsContainer />,
    },
    /* 
    legal: {
      show: !hasStorePoliciesFeatureDisabled,
      name: 'Legal',
      path: '/configure/legal',
      component: <LegalContainer />,
      icon: <BookIcon className={classes.subRouteIcon} />,
    },
    services: {
      show: true,
      name: 'Servicios',
      path: '/configure/services',
      component: null,
      icon: <HeadsetMicIcon className={classes.subRouteIcon} />,
      disabled: true,
    }, */
  };

  const subRoutesArray = Object.keys(subRoutes).map(k => subRoutes[k]);

  const subRoute: ?ConfigureSubRoute = subRoutesArray.find(
    (route: ConfigureSubRoute) => location.pathname.startsWith(route.path)
  );

  return (
    <div className={classes.root}>
      <AlertDueDateTier />
      <Hidden mdUp>
        {subRoute ? (
          <div className={classes.subRouteNameWrap}>
            <CustomButton to="/configure">
              <ArrowBack />
            </CustomButton>
            {subRoute.icon}
            <Typography component={'span'} className={classes.subRouteNameText}>
              {subRoute.name}
            </Typography>
            {subRoute.extra && subRoute.extra}
          </div>
        ) : (
          <div className={classes.subRouteNameWrap}>
            <CustomButton to="/tools">
              <ArrowBack />
            </CustomButton>
            <Typography component={'span'} className={classes.subRouteNameText}>
              Regresar
            </Typography>
          </div>
        )}
      </Hidden>

      <main className={classes.content}>
        <Hidden smDown>
          <div className={classes.headerWrapper}>
            <Grid container justify="space-between" alignItems="center">
              <Grid item>
                <Typography className={classes.title}>
                  {/*{subRoute ? (
                    <IconButton
                      style={{alignSelf: 'center'}}
                      onClick={() => history.goBack()}
                    >
                      <ArrowBack />
                    </IconButton>
                  ) : (
                    ''
                  )}*/}
                  Configuración
                </Typography>
              </Grid>
              <Grid item>
                <CustomButton
                  href={TIENDADA_LINKS.customerSupport.general}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={classes.ayudaButton}
                  startIcon={<HelpTwoTone />}
                >
                  Ayuda
                </CustomButton>
                <CustomButton
                  href={getTutorialLinkByPathname(location.pathname)}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={classes.tutorialsButton}
                  startIcon={<PlayCircleFilledTwoTone />}
                >
                  Tutoriales
                </CustomButton>
              </Grid>
            </Grid>
            {subRoute && (
              <div className={classes.subRouteHeader}>
                {subRoute.icon} {subRoute.name} {subRoute.extra}
              </div>
            )}
          </div>
        </Hidden>
        {subRoute && subRoute.tierRestricted && (
          <div className={classes.upsellMessage}>
            <div style={{display: 'flex', alignItems: 'center'}}>
              <InfoOutlined style={{marginRight: 16}} />
              Suscríbete a nuestros planes para acceder a funcionalidades PRO e
              impulsar tu negocio
            </div>
            <CustomButton
              className={classes.upgradeTierButton}
              to="/tiers-list"
            >
              Mejorar Plan
            </CustomButton>
          </div>
        )}
        <Switch>
          <Route exact path="/configure">
            <>
              {subRoutesArray.map((route: ConfigureSubRoute, idx: number) =>
                !route.show ? null : (
                  <CustomButton
                    key={idx}
                    startIcon={route.icon}
                    disabled={route.disabled}
                    component={Link}
                    to={route.path}
                    className={`${
                      route.disabled
                        ? classes.disabledConfigureButton
                        : classes.configureButton
                    }`}
                  >
                    {route.name}
                  </CustomButton>
                )
              )}
              {/* <Hidden mdUp>
                {drawerOpen && (
                  <Helmet>
                    <style type="text/css">{`
                      body {
                        overflow: hidden;
                      }
                    `}</style>
                  </Helmet>
                )}
              </Hidden>
              <ClickAwayListener onClickAway={handleAwayClick}>
                <div>
                  <Hidden mdUp>
                    <Collapse
                      in={drawerOpen}
                      timeout={{appear: 1000, exit: 50}}
                    >
                      {menuList}
                    </Collapse>
                  </Hidden>
                </div>
              </ClickAwayListener>
              <Hidden mdUp>
                {drawerOpen && <div className={classes.veil} />}
              </Hidden> */}
              {/* <Container className={classes.containerWrap}>
                <aside className={classes.menuWrap}>{tabs()}</aside>
                <Switch>
                  {subRoutesArray.map(
                    (route: ConfigureSubRoute, idx: number) => (
                      <Route
                        key={idx}
                        path={route.path}
                        component={route.component}
                      />
                    )
                  )}
                </Switch>
              </Container> */}
            </>
          </Route>
          {subRoutesArray.map((route: ConfigureSubRoute, idx: number) => (
            <Route
              exact={!!route.exact}
              key={`configure-route-${idx}`}
              path={route.path}
              // component={route.component}
            >
              <div className={classes.subRouteContent}>{route.component}</div>
            </Route>
          ))}
        </Switch>
        {subRoute &&
          (subRoute.path === '/configure/logistics' ||
            subRoute.path === '/configure/payment-methods') &&
          subRoute.tierRestricted && (
            <div className={classes.upsellMessageBottom}>
              <InfoOutlined style={{marginRight: 16}} />
              Recuerda que la versión gratis envía los pedidos recibidos a tu
              WhatsApp a través de un mensaje automatizado que incluye toda la
              información de la compra.
            </div>
          )}
      </main>
      <div className={classes.contentBottom}>
        <Hidden mdUp>
          <ButtonGroup>
            <CustomButton
              href={getTutorialLinkByPathname(location.pathname)}
              target="_blank"
              rel="noopener noreferrer"
              className={classes.groupButton}
              startIcon={<PlayCircleFilledTwoTone />}
            >
              Tutoriales
            </CustomButton>
            <CustomButton
              href={TIENDADA_LINKS.customerSupport.general}
              target="_blank"
              rel="noopener noreferrer"
              className={classes.groupButton}
              startIcon={<HelpTwoTone />}
            >
              Ayuda
            </CustomButton>
          </ButtonGroup>
        </Hidden>
      </div>
    </div>
  );
}

Configure.propTypes = {
  store: PropTypes.object,
  user: PropTypes.object.isRequired,
};
